import React from 'react';
import { BookOpenIcon, CheckCircleIcon } from 'lucide-react';
export function Chapters() {
  return <section className="py-16 bg-gray-50" data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <div className="text-center mb-12" data-id="element-98">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-99">
            What You'll Discover Inside
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-100">
            21 pages of concentrated wisdom and actionable strategies to
            transform your mindset and regain your vitality.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-101">
          <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-102">
            <h3 className="text-xl font-semibold text-gray-900 flex items-center mb-6" data-id="element-103">
              <BookOpenIcon className="h-6 w-6 text-blue-600 mr-2" data-id="element-104" />
              Table of Contents
            </h3>
            <div className="space-y-6" data-id="element-105">
              <div data-id="element-106">
                <h4 className="font-medium text-gray-900" data-id="element-107">Introduction</h4>
                <ul className="mt-2 text-gray-600 space-y-1" data-id="element-108">
                  <li className="flex items-start" data-id="element-109">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-110" />
                    <span data-id="element-111">Why Your Mindset Shapes Your Well-Being</span>
                  </li>
                  <li className="flex items-start" data-id="element-112">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-113" />
                    <span data-id="element-114">The Power of Resetting Your Inner World</span>
                  </li>
                </ul>
              </div>
              <div data-id="element-115">
                <h4 className="font-medium text-gray-900" data-id="element-116">
                  Chapter 1: The Foundation of a Young Mind
                </h4>
                <ul className="mt-2 text-gray-600 space-y-1" data-id="element-117">
                  <li className="flex items-start" data-id="element-118">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-119" />
                    <span data-id="element-120">Understanding Mental Flexibility</span>
                  </li>
                  <li className="flex items-start" data-id="element-121">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-122" />
                    <span data-id="element-123">How Age Is More Mental Than Physical</span>
                  </li>
                </ul>
              </div>
              <div data-id="element-124">
                <h4 className="font-medium text-gray-900" data-id="element-125">
                  Chapter 2: Resetting Your Mindset
                </h4>
                <ul className="mt-2 text-gray-600 space-y-1" data-id="element-126">
                  <li className="flex items-start" data-id="element-127">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-128" />
                    <span data-id="element-129">Identifying Mental Blocks</span>
                  </li>
                  <li className="flex items-start" data-id="element-130">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-131" />
                    <span data-id="element-132">Practical Steps to Shift Your Perspective</span>
                  </li>
                </ul>
              </div>
              <div data-id="element-133">
                <h4 className="font-medium text-gray-900" data-id="element-134">
                  Chapter 3: Nourishing Body and Brain
                </h4>
                <ul className="mt-2 text-gray-600 space-y-1" data-id="element-135">
                  <li className="flex items-start" data-id="element-136">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-137" />
                    <span data-id="element-138">Foods That Boost Mental Vitality</span>
                  </li>
                  <li className="flex items-start" data-id="element-139">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-140" />
                    <span data-id="element-141">Movement and Exercise for Cognitive Sharpness</span>
                  </li>
                </ul>
              </div>
              <div data-id="element-142">
                <h4 className="font-medium text-gray-900" data-id="element-143">And Much More...</h4>
                <p className="mt-2 text-gray-600" data-id="element-144">
                  Chapters on Emotional Rejuvenation, Mindfulness, and Designing
                  a Vitality Lifestyle.
                </p>
              </div>
            </div>
          </div>
          <div className="space-y-8" data-id="element-145">
            <div className="bg-blue-600 text-white p-6 rounded-lg" data-id="element-146">
              <h3 className="text-xl font-bold mb-4" data-id="element-147">
                Why This Guide Is Different
              </h3>
              <p className="mb-4" data-id="element-148">
                Unlike generic self-help books, "Young Mind" provides a complete
                system specifically designed to reset your mental patterns and
                restore your natural vitality.
              </p>
              <ul className="space-y-2" data-id="element-149">
                <li className="flex items-start" data-id="element-150">
                  <svg className="h-5 w-5 text-blue-300 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-151">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-152" />
                  </svg>
                  <span data-id="element-153">Concise and actionable - no fluff or filler</span>
                </li>
                <li className="flex items-start" data-id="element-154">
                  <svg className="h-5 w-5 text-blue-300 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-155">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-156" />
                  </svg>
                  <span data-id="element-157">Science-backed techniques you can implement today</span>
                </li>
                <li className="flex items-start" data-id="element-158">
                  <svg className="h-5 w-5 text-blue-300 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-159">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-160" />
                  </svg>
                  <span data-id="element-161">
                    Holistic approach addressing mind, body, and emotions
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-green-50 p-6 rounded-lg border border-green-200" data-id="element-162">
              <div className="flex items-center mb-4" data-id="element-163">
                <div className="bg-green-100 rounded-full p-2 mr-4" data-id="element-164">
                  <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-165">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-166" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-167">
                  Immediate Results
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-168">
                Readers report feeling more energetic and mentally sharp within
                just days of implementing the techniques in this guide.
              </p>
              <div className="mt-4" data-id="element-169">
                <a href="#buy-now" className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" data-id="element-170">
                  Start Your Transformation
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}